(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oracle-cristallin"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.getElementById("crystal-oracle-demo");
  if (!root) return;

  const messages = [
    {
      facet: "Facette de clarté",
      title: "La réponse est déjà proche",
      copy: "Tu ne manques peut-être pas de réponse. Tu essaies simplement de l’entendre au milieu de trop nombreuses voix. Ce qui est juste pour toi ne crie pas : cela apporte une sensation d’espace et de simplicité.",
      key: "Je m’autorise à voir clairement, sans forcer la réponse.",
      ritual: "Pose une main sur ton cœur et l’autre sur ton front. Respire trois fois, puis demande : « Quelle est la prochaine étape, seulement la prochaine ? »",
      door: "Réserver ma guidance en direct",
      destination: "Cette porte conduira vers Éclairage Express ou la Séance Clarté & Réalignement."
    },
    {
      facet: "Facette de clarté",
      title: "Le brouillard ne signifie pas que tu es perdue",
      copy: "Lorsque trop de pensées cherchent une réponse en même temps, le chemin semble disparaître. Pourtant, il est toujours là. Tu n’as pas à résoudre toute ton histoire aujourd’hui : seulement à reconnaître ce qui te rend un peu plus légère.",
      key: "Je choisis ce qui m’apporte de l’espace, pas ce qui nourrit ma peur.",
      ritual: "Écris les trois mots qui décrivent le mieux ta situation. Entoure celui qui semble contenir le véritable nœud, puis respire doucement en le regardant.",
      door: "Réserver ma guidance en direct",
      destination: "Cette porte conduira vers Éclairage Express ou la Séance Clarté & Réalignement."
    },
    {
      facet: "Facette de clarté",
      title: "Une vérité simple cherche à émerger",
      copy: "Tu as peut-être déjà compris l’essentiel, mais une partie de toi attend encore une certitude parfaite. La clarté ne retire pas toujours le doute. Elle te permet d’avancer avec douceur malgré lui.",
      key: "Je peux avancer sans posséder toutes les réponses.",
      ritual: "Demande-toi : « Si je n’avais rien à prouver, que choisirais-je maintenant ? » Accueille la première réponse sans la corriger.",
      door: "Réserver ma guidance en direct",
      destination: "Cette porte conduira vers la Séance Clarté & Réalignement."
    },
    {
      facet: "Facette de protection",
      title: "Tu peux rester ouverte sans tout absorber",
      copy: "Ta sensibilité n’est pas une faiblesse. Elle devient épuisante lorsque ton énergie ne sait plus ce qui lui appartient. Aujourd’hui, tu es invitée à préserver ton espace sans fermer ton cœur.",
      key: "Je rends ce qui ne m’appartient pas et je rappelle doucement mon énergie à moi.",
      ritual: "Passe lentement tes mains autour de ton corps, comme si tu redessinais les contours d’une bulle de lumière.",
      door: "Découvrir le Bouclier de Michaël",
      destination: "Cette porte conduira vers l’audio du Bouclier de Michaël."
    },
    {
      facet: "Facette de protection",
      title: "Tout ce que tu ressens ne t’appartient pas",
      copy: "Ta grande réceptivité peut te faire porter des ambiances, des attentes ou des émotions venues d’ailleurs. Tu n’as pas besoin de les analyser pour t’en séparer. Tu peux simplement reconnaître : ceci n’est pas à moi.",
      key: "Je distingue avec amour ce qui est mien de ce qui ne l’est pas.",
      ritual: "Secoue doucement tes mains vers le sol, puis pose-les sur ton cœur. Imagine que ton énergie revient à l’intérieur de tes propres contours.",
      door: "Découvrir le Bouclier de Michaël",
      destination: "Cette porte conduira vers l’audio du Bouclier de Michaël."
    },
    {
      facet: "Facette de protection",
      title: "Ta lumière a besoin de contours",
      copy: "Dire non, ralentir ou prendre de la distance ne diminue pas ton amour. Une frontière juste ne punit personne : elle permet à ton énergie de rester entière et à tes oui de redevenir sincères.",
      key: "Mes limites protègent la qualité de ma présence.",
      ritual: "Trace lentement un cercle devant toi avec ton index. À l’intérieur de ce cercle, nomme une chose que tu souhaites préserver aujourd’hui.",
      door: "Découvrir le Bouclier de Michaël",
      destination: "Cette porte conduira vers l’audio du Bouclier de Michaël."
    },
    {
      facet: "Facette de libération",
      title: "Ce poids n’a plus besoin de voyager avec toi",
      copy: "Quelque chose arrive peut-être au terme de son chemin. Tu n’as pas besoin de tout comprendre pour commencer à déposer. Ton énergie sait parfois se libérer avant que ton esprit trouve les mots.",
      key: "Je peux honorer ce qui fut, sans continuer à le porter.",
      ritual: "Expire longuement par la bouche trois fois. À chaque expiration, imagine qu’une ancienne tension quitte doucement ton corps.",
      door: "Réserver mon soin énergétique",
      destination: "Cette porte conduira vers le Soin de libération et de réalignement."
    },
    {
      facet: "Facette de libération",
      title: "La porte peut se fermer avec douceur",
      copy: "Tu n’as pas besoin de renier ce que tu as vécu pour reconnaître qu’un cycle est terminé. Certaines portes se ferment sans colère, simplement parce que ton âme n’habite plus le même espace.",
      key: "Je remercie le chemin parcouru et je libère ce qui est achevé.",
      ritual: "Ouvre tes mains devant toi, puis referme-les doucement sur ton cœur. Sur l’expiration, murmure : « Je laisse partir en paix. »",
      door: "Réserver mon soin énergétique",
      destination: "Cette porte conduira vers le Soin de libération et de réalignement."
    },
    {
      facet: "Facette de libération",
      title: "Ton corps demande moins de lutte",
      copy: "Ce que tu combats depuis longtemps a peut-être surtout besoin d’être entendu. La libération ne vient pas toujours d’un grand bouleversement. Elle peut commencer lorsque ton corps comprend qu’il n’a plus à se défendre à chaque instant.",
      key: "Je relâche la lutte et j’écoute ce qui demande de la douceur.",
      ritual: "Pose tes mains autour de ton plexus solaire. Balance lentement ton buste en dessinant un huit, sans chercher à provoquer une sensation particulière.",
      door: "Réserver mon soin énergétique",
      destination: "Cette porte conduira vers le Soin de libération et de réalignement."
    },
    {
      facet: "Facette de l’intention",
      title: "Ce que tu nommes commence à prendre forme",
      copy: "Ton désir demande moins d’effort et davantage de présence. Avant de chercher comment il se réalisera, offre-lui une direction claire et un espace sacré dans ta vie.",
      key: "Je formule mon intention avec clarté et je laisse la vie ouvrir le chemin juste.",
      ritual: "Écris une seule phrase commençant par : « Je suis prête à accueillir… » Puis dépose un cristal ou une bougie sur cette intention.",
      door: "Recevoir ma guidance audio sous 48 h",
      destination: "Cette porte conduira vers le Rituel vibratoire personnalisé."
    },
    {
      facet: "Facette de l’intention",
      title: "Ton intention a besoin d’une place",
      copy: "Un désir devient plus vivant lorsqu’il cesse d’être une pensée passagère. Offre-lui un geste, un objet ou un rendez-vous avec toi-même. Ce que tu honores régulièrement commence à transformer ta manière d’habiter le monde.",
      key: "Je donne une place réelle à ce que mon cœur appelle.",
      ritual: "Choisis un petit espace chez toi. Dépose-y un objet qui représente ton intention et touche-le chaque matin pendant sept jours.",
      door: "Recevoir ma guidance audio sous 48 h",
      destination: "Cette porte conduira vers le Rituel vibratoire personnalisé."
    },
    {
      facet: "Facette de l’intention",
      title: "Ce désir mérite d’être nommé",
      copy: "Tu as peut-être rendu ton souhait plus petit pour qu’il paraisse raisonnable ou acceptable. Le cristal t’invite à le nommer sans t’excuser. Une intention sincère n’exige pas de connaître immédiatement le chemin.",
      key: "J’honore ce que je désire sans le diminuer.",
      ritual: "Prononce ton intention à voix haute une seule fois, au présent. Reste ensuite quelques secondes en silence pour sentir comment ton corps la reçoit.",
      door: "Recevoir ma guidance audio sous 48 h",
      destination: "Cette porte conduira vers le Rituel vibratoire personnalisé."
    },
    {
      facet: "Facette de transformation",
      title: "Tu ne te perds pas, tu changes de rive",
      copy: "Tu traverses peut-être un passage dans lequel l’ancienne version de toi ne peut plus te guider. L’inconnu ne signifie pas que tu es égarée. Il peut être l’espace où une nouvelle manière d’exister commence à naître.",
      key: "Je n’ai pas besoin de connaître toute la traversée pour faire confiance au prochain pas.",
      ritual: "Pose tes deux pieds au sol. Prononce ton prénom, puis dis : « Je suis ici. Je m’accompagne avec douceur. »",
      door: "Être accompagnée dans ma Grande Traversée",
      destination: "Cette porte conduira vers l’accompagnement La Grande Traversée."
    },
    {
      facet: "Facette de transformation",
      title: "L’entre-deux est un passage sacré",
      copy: "Tu n’es plus tout à fait celle que tu étais, sans encore savoir qui tu deviens. Cet espace peut sembler vide, mais il est fertile. Ne le remplis pas trop vite : une nouvelle forme cherche à apparaître.",
      key: "Je respecte le temps nécessaire à ma métamorphose.",
      ritual: "Allume une bougie et observe sa flamme pendant une minute. Dis intérieurement : « J’accueille ce qui naît, même si je ne le comprends pas encore. »",
      door: "Être accompagnée dans ma Grande Traversée",
      destination: "Cette porte conduira vers l’accompagnement La Grande Traversée."
    },
    {
      facet: "Facette de transformation",
      title: "Ta nouvelle forme n’a pas à ressembler à l’ancienne",
      copy: "Tu peux aimer ce que tu as été sans chercher à le reproduire. Certains passages ne restaurent pas l’ancienne vie : ils révèlent une manière plus vraie de te tenir au monde.",
      key: "Je me donne la permission de devenir autrement.",
      ritual: "Place une main derrière ta nuque et l’autre sous ton nombril. Inspire en pensant « j’accueille », puis expire en pensant « je deviens ».",
      door: "Être accompagnée dans ma Grande Traversée",
      destination: "Cette porte conduira vers l’accompagnement La Grande Traversée."
    },
    {
      facet: "Facette de l’ancrage",
      title: "Pour aujourd’hui, tu n’as rien à accomplir",
      copy: "Tout ne demande pas une réponse, un soin ou une décision. Ton énergie peut simplement avoir besoin de silence, de lenteur et d’un lieu où elle n’a rien à prouver.",
      key: "Je peux m’arrêter sans perdre mon chemin.",
      ritual: "Bois lentement un verre d’eau. Sens tes pieds, relâche ta mâchoire et reste quelques instants sans chercher à modifier ce que tu ressens.",
      door: "Entrer dans Le Sanctuaire",
      destination: "Cette porte conduira vers Le Sanctuaire sur Skool — ou pourra simplement inviter à se reposer."
    },
    {
      facet: "Facette de l’ancrage",
      title: "Reviens à ce qui est simple",
      copy: "Ton énergie n’a peut-être pas besoin d’une nouvelle explication. Elle peut avoir besoin d’eau, d’air, de nourriture, de silence ou d’un pas posé lentement après l’autre. Le sacré sait aussi habiter les gestes ordinaires.",
      key: "Je reviens au simple, et le simple me ramène à moi.",
      ritual: "Choisis un geste très concret à accomplir maintenant : boire, ouvrir une fenêtre, marcher quelques minutes ou ranger un petit espace.",
      door: "Entrer dans Le Sanctuaire",
      destination: "Cette porte conduira vers Le Sanctuaire sur Skool — ou pourra simplement inviter à prendre soin de soi maintenant."
    },
    {
      facet: "Facette de l’ancrage",
      title: "Ton corps est ta première maison",
      copy: "Avant les réponses, les décisions et les signes, il y a ce corps qui te porte. Revenir à lui ne réduit pas ta spiritualité. Cela lui offre un lieu où se déposer et devenir vivante.",
      key: "J’habite pleinement le corps qui me ramène au présent.",
      ritual: "Presse doucement tes pieds contre le sol pendant trois respirations. Observe ensuite trois sensations physiques sans chercher à les changer.",
      door: "Entrer dans Le Sanctuaire",
      destination: "Cette porte conduira vers Le Sanctuaire sur Skool — ou pourra simplement inviter à rester quelques instants dans le corps."
    },
    {
      facet: "Facette de clarté",
      element: "Air",
      need: "Apaiser la rumination",
      title: "Toutes tes pensées ne demandent pas une réponse",
      copy: "Ton esprit essaie peut-être de te protéger en anticipant chaque possibilité. Cette vigilance a pu t’aider à éviter l’imprévu, mais elle t’épuise lorsqu’elle transforme chaque pensée en problème à résoudre. Tu peux laisser certaines questions ouvertes sans te mettre en danger.",
      key: "Je laisse passer une pensée sans être obligée de la suivre.",
      ritual: "Observe une pensée qui revient souvent. Nomme-la simplement : « Voici une pensée, pas une consigne. » Puis ramène ton attention vers trois choses que tu vois autour de toi.",
      door: "Réserver ma guidance en direct",
      destination: "Cette porte conduira vers une guidance personnalisée pour éclairer la situation qui occupe ton esprit."
    },
    {
      facet: "Facette de clarté",
      element: "Eau",
      need: "Distinguer urgence émotionnelle et priorité réelle",
      title: "Ce qui semble urgent n’est pas toujours essentiel",
      copy: "Une émotion intense peut donner l’impression qu’une décision doit être prise immédiatement. Pourtant, l’intensité ne mesure pas toujours l’importance. Lorsque les eaux s’apaisent un peu, ce qui compte vraiment devient souvent plus visible.",
      key: "Je peux attendre que l’émotion se dépose avant de choisir.",
      ritual: "Bois trois gorgées d’eau très lentement. Entre chaque gorgée, demande-toi : « Qu’est-ce qui restera important demain ? »",
      door: "Réserver ma guidance en direct",
      destination: "Cette porte conduira vers une guidance personnalisée pour retrouver de la clarté sans décider dans l’urgence."
    },
    {
      facet: "Facette de clarté",
      element: "Terre",
      need: "Sortir du perfectionnisme",
      title: "La bonne décision n’a pas besoin d’être parfaite",
      copy: "Tu cherches peut-être le choix qui ne décevra personne, ne fermera aucune porte et ne provoquera aucun regret. Un tel choix existe rarement. La clarté peut simplement être la décision assez juste pour la femme que tu es aujourd’hui.",
      key: "Je choisis ce qui est suffisamment juste pour avancer.",
      ritual: "Écris deux options. Sous chacune, note seulement ce qu’elle protège et ce qu’elle rend possible. Laisse de côté, pour un instant, ce qu’elle pourrait prouver aux autres.",
      door: "Réserver ma guidance en direct",
      destination: "Cette porte conduira vers une guidance personnalisée pour éclairer un choix concret."
    },
    {
      facet: "Facette de protection",
      element: "Terre",
      need: "Retrouver le droit de choisir",
      title: "Ton oui mérite de passer par toi",
      copy: "Tu as peut-être appris à répondre vite pour rassurer, aider ou éviter de décevoir. Mais un oui donné avant de t’écouter peut devenir une fatigue silencieuse. Prendre un temps de réponse n’est pas rejeter l’autre : c’est te laisser une place dans ta propre décision.",
      key: "Je peux prendre le temps de sentir mon oui et mon non.",
      ritual: "Avant ta prochaine réponse, pose une main sur ton ventre et dis : « Je vais y réfléchir. » Observe ensuite si ton corps s’ouvre, se serre ou demande du temps.",
      door: "Découvrir le Bouclier de Michaël",
      destination: "Cette porte conduira vers le Bouclier de Michaël pour soutenir des limites plus conscientes."
    },
    {
      facet: "Facette de protection",
      element: "Feu",
      need: "Écouter la colère protectrice",
      title: "Ta colère protège peut-être une frontière",
      copy: "Ta colère ne fait pas de toi une femme dure ou moins lumineuse. Elle peut apparaître lorsqu’une limite a été franchie trop souvent ou lorsqu’une part de toi n’a pas été entendue. Tu n’as pas besoin de la laisser tout brûler pour reconnaître ce qu’elle protège.",
      key: "J’écoute le message de ma colère sans lui abandonner mes gestes.",
      ritual: "Presse tes pieds dans le sol et expire fortement trois fois. Termine cette phrase : « Ce que je ne veux plus laisser passer, c’est… »",
      door: "Découvrir le Bouclier de Michaël",
      destination: "Cette porte conduira vers le Bouclier de Michaël pour canaliser et protéger ton espace."
    },
    {
      facet: "Facette de protection",
      element: "Eau",
      need: "Aimer sans s’oublier",
      title: "Tu peux aimer sans être disponible à tout",
      copy: "Ton amour n’est pas mesuré par le nombre de fois où tu t’interromps pour répondre aux besoins des autres. Être présente ne signifie pas être accessible à chaque instant. Une relation juste peut respirer même lorsque tu reviens vers toi.",
      key: "Mon amour reste entier lorsque je protège mon temps et mon énergie.",
      ritual: "Choisis aujourd’hui un moment de vingt minutes sans sollicitation. Ferme la porte, éloigne ton téléphone et laisse cet espace t’appartenir pleinement.",
      door: "Découvrir le Bouclier de Michaël",
      destination: "Cette porte conduira vers le Bouclier de Michaël pour préserver ton énergie relationnelle."
    },
    {
      facet: "Facette de libération",
      element: "Terre",
      need: "Déposer la surresponsabilité",
      title: "Tu peux déposer le rôle de celle qui tient tout",
      copy: "Ta force a peut-être permis à beaucoup de choses de continuer lorsque personne d’autre ne semblait pouvoir les porter. Cette capacité est réelle, mais elle ne t’oblige pas à devenir le pilier permanent de chaque situation. Être soutenue ne retire rien à ta valeur.",
      key: "Je rends à chacun sa part et je garde seulement ce qui m’appartient.",
      ritual: "Prends un objet un peu lourd dans tes mains. Nomme une responsabilité qui n’est pas entièrement la tienne, puis dépose l’objet au sol en expirant.",
      door: "Réserver mon soin énergétique",
      destination: "Cette porte conduira vers le soin énergétique de libération et de réalignement."
    },
    {
      facet: "Facette de libération",
      element: "Eau",
      need: "Accueillir une tristesse retenue",
      title: "Ce qui n’a pas été pleuré cherche parfois une rivière",
      copy: "Tu as peut-être continué à avancer parce qu’il le fallait, en laissant ta tristesse attendre derrière ta force. Elle ne demande pas forcément une explication. Elle peut simplement avoir besoin d’un espace où elle n’est ni corrigée, ni pressée de disparaître.",
      key: "Je peux laisser une émotion circuler sans perdre pied.",
      ritual: "Pose un bol d’eau devant toi. Reste deux minutes en silence et autorise ce qui vient, même si aucune larme n’apparaît. Verse ensuite l’eau dans la terre ou dans l’évier.",
      door: "Réserver mon soin énergétique",
      destination: "Cette porte conduira vers le soin énergétique de libération et de réalignement."
    },
    {
      facet: "Facette de libération",
      element: "Air",
      need: "Sortir de l’analyse du passé",
      title: "Comprendre encore ne changera peut-être plus l’histoire",
      copy: "Ton esprit revient peut-être sur les mêmes scènes pour trouver l’explication qui rendrait enfin le passé acceptable. Comprendre peut éclairer, mais cela ne peut pas toujours réparer. À un certain moment, ton cœur demande moins d’analyse et davantage de paix.",
      key: "Je garde la compréhension utile et je libère la recherche sans fin.",
      ritual: "Écris une phrase commençant par : « Ce que je sais maintenant suffit pour… » Termine-la, plie la feuille et range-la hors de ta vue pour aujourd’hui.",
      door: "Réserver mon soin énergétique",
      destination: "Cette porte conduira vers le soin énergétique de libération et de réalignement."
    },
    {
      facet: "Facette de l’intention",
      element: "Feu",
      need: "Retrouver le désir",
      title: "Ton désir n’est pas éteint, il manque peut-être d’espace",
      copy: "Lorsque tu réponds longtemps aux urgences, aux attentes et aux besoins des autres, ton propre désir peut devenir presque inaudible. Il n’a pas disparu. Il attend peut-être un espace où il ne devra ni être utile, ni être raisonnable pour exister.",
      key: "Je redonne une place à ce qui me rend vivante.",
      ritual: "Pendant cinq minutes, écris tout ce que tu aimerais vivre si rien ne devait être productif. Entoure ensuite la phrase qui réchauffe le plus ton corps.",
      door: "Recevoir ma guidance audio sous 48 h",
      destination: "Cette porte conduira vers la guidance audio personnalisée pour clarifier ce que ton désir cherche à ouvrir."
    },
    {
      facet: "Facette de l’intention",
      element: "Eau",
      need: "S’autoriser à recevoir",
      title: "Recevoir ne te rend pas passive",
      copy: "Tu sais peut-être donner, organiser, anticiper et prendre soin. Recevoir peut alors sembler inconfortable, comme si tu devais immédiatement rendre ou mériter ce qui t’est offert. Pourtant, accueillir est aussi un mouvement vivant : il permet à l’échange de circuler dans les deux sens.",
      key: "Je peux recevoir sans dette et sans diminuer ma force.",
      ritual: "Accepte aujourd’hui une aide, un compliment ou un geste sans le minimiser. Réponds seulement : « Merci, je le reçois. »",
      door: "Recevoir ma guidance audio sous 48 h",
      destination: "Cette porte conduira vers la guidance audio personnalisée pour éclairer ta manière de recevoir et d’avancer."
    },
    {
      facet: "Facette de l’intention",
      element: "Terre",
      need: "Respecter le temps de maturation",
      title: "La graine demande du temps",
      copy: "Tu as peut-être déjà planté une intention sincère. La déterrer chaque jour pour vérifier si elle pousse ne l’aidera pas à germer. Certaines créations ont besoin d’être arrosées, protégées, aimées et laissées un temps dans l’obscurité avant de montrer leur première pousse.",
      key: "Je nourris mon intention sans exiger qu’elle se révèle immédiatement.",
      ritual: "Arrose une plante ou humidifie un peu de terre. Pendant ce geste, nomme une action simple qui nourrira ton intention cette semaine, puis laisse le reste mûrir.",
      door: "Recevoir ma guidance audio sous 48 h",
      destination: "Cette porte conduira vers la guidance audio personnalisée pour discerner ce qui demande action et ce qui demande patience."
    },
    {
      facet: "Facette de transformation",
      element: "Eau",
      need: "Faire le deuil d’une ancienne attente",
      title: "Tu peux faire le deuil de celle que tu pensais devoir devenir",
      copy: "Certaines transformations ne concernent pas seulement ce que tu quittes, mais l’image de toi que tu avais longtemps essayé d’atteindre. Renoncer à cette ancienne attente n’est pas échouer. C’est peut-être cesser de poursuivre une vie qui ne te ressemble plus.",
      key: "Je libère l’ancienne promesse et j’écoute la femme que je deviens.",
      ritual: "Écris : « Je n’ai plus besoin de devenir… » puis complète la phrase. Retourne la feuille et écris : « Je souhaite maintenant me sentir… »",
      door: "Être accompagnée dans ma Grande Traversée",
      destination: "Cette porte conduira vers l’accompagnement La Grande Traversée."
    },
    {
      facet: "Facette de transformation",
      element: "Feu",
      need: "Reprendre sa puissance personnelle",
      title: "Ta puissance revient lorsque tu cesses de te diminuer",
      copy: "Tu as peut-être appris à parler moins fort, à demander moins ou à rendre tes élans plus petits pour rester acceptable. Cette adaptation a pu protéger tes liens. Mais ta présence n’a pas besoin de s’effacer pour que les autres puissent exister.",
      key: "Je peux prendre ma place sans prendre celle de quelqu’un d’autre.",
      ritual: "Tiens-toi debout, les pieds écartés à la largeur du bassin. Prononce une fois, à voix claire, quelque chose que tu désires ou que tu ne veux plus minimiser.",
      door: "Être accompagnée dans ma Grande Traversée",
      destination: "Cette porte conduira vers l’accompagnement La Grande Traversée."
    },
    {
      facet: "Facette de transformation",
      element: "Terre",
      need: "Se reconstruire par étapes",
      title: "Tu n’as pas à te reconstruire d’un seul bloc",
      copy: "Après un grand changement, tu peux ressentir la pression de redevenir rapidement stable, claire et forte. Mais une nouvelle base se construit pierre après pierre. La lenteur n’est pas un retard lorsqu’elle crée quelque chose qui pourra vraiment te soutenir.",
      key: "Je bâtis ma nouvelle stabilité par gestes simples et fidèles.",
      ritual: "Choisis un seul espace très petit à remettre en ordre : un tiroir, un sac ou un coin de table. Laisse ce geste représenter la première pierre, pas toute la maison.",
      door: "Être accompagnée dans ma Grande Traversée",
      destination: "Cette porte conduira vers l’accompagnement La Grande Traversée."
    },
    {
      facet: "Facette de l’ancrage",
      element: "Air",
      need: "Ramener le mental vers le corps",
      title: "Ton esprit court peut-être parce qu’il cherche un lieu sûr",
      copy: "Un mental agité n’est pas forcément un ennemi à faire taire. Il peut essayer de surveiller, prévoir et protéger. Plutôt que de lutter contre lui, offre-lui un endroit concret où revenir : ton souffle, tes appuis et ce qui existe ici, maintenant.",
      key: "Je remercie mon esprit et je reviens doucement dans le présent.",
      ritual: "Nomme cinq choses que tu vois, quatre que tu peux toucher et trois que tu entends. Termine en sentant le poids de ton corps sur son support.",
      door: "Entrer dans Le Sanctuaire",
      destination: "Cette porte conduira vers Le Sanctuaire sur Skool — ou pourra simplement t’inviter à rester avec cette pratique."
    },
    {
      facet: "Facette de l’ancrage",
      element: "Terre",
      need: "Se reposer sans culpabilité",
      title: "Le repos n’est pas une récompense",
      copy: "Tu n’as pas besoin d’avoir tout terminé pour mériter de t’arrêter. Si le repos n’arrive qu’après la dernière tâche, il sera toujours repoussé. Ton corps n’est pas une machine que tu remercies seulement lorsqu’elle a suffisamment produit.",
      key: "Je me repose parce que je suis vivante, pas parce que j’ai tout accompli.",
      ritual: "Accorde-toi dix minutes sans objectif. Assieds-toi ou allonge-toi, pose une main sur ton ventre et laisse ce temps n’aboutir à rien.",
      door: "Entrer dans Le Sanctuaire",
      destination: "Cette porte conduira vers Le Sanctuaire sur Skool — ou pourra simplement t’autoriser à te reposer maintenant."
    },
    {
      facet: "Facette de l’ancrage",
      element: "Eau",
      need: "Accepter le soutien",
      title: "Tu as le droit d’être soutenue",
      copy: "Ton autonomie est une force, mais elle n’a pas besoin de devenir une solitude. Demander, accepter ou recevoir une présence ne signifie pas que tu es incapable. Certaines traversées deviennent plus douces lorsqu’elles ne sont plus portées en silence.",
      key: "Je reste souveraine même lorsque je m’appuie sur un lien sûr.",
      ritual: "Pense à une personne ou à un espace fiable. Écris une demande simple et précise que tu pourrais formuler, même si tu choisis de ne l’envoyer que plus tard.",
      door: "Entrer dans Le Sanctuaire",
      destination: "Cette porte conduira vers Le Sanctuaire sur Skool pour avancer entourée — ou pourra simplement t’aider à nommer ton besoin de soutien."
    }
  ];

  const reflectionQuestions = {
    "La réponse est déjà proche": "Quelle voix intérieure devient audible lorsque tu cesses de chercher la réponse parfaite ?",
    "Le brouillard ne signifie pas que tu es perdue": "Qu’est-ce qui te rendrait un peu plus légère aujourd’hui, même sans tout résoudre ?",
    "Une vérité simple cherche à émerger": "Que choisirais-tu maintenant si tu n’avais rien à prouver à personne ?",
    "Tu peux rester ouverte sans tout absorber": "Quelle émotion ou attente pourrais-tu rendre aujourd’hui parce qu’elle ne t’appartient pas ?",
    "Tout ce que tu ressens ne t’appartient pas": "Dans quelle situation sens-tu que ton énergie se mélange le plus à celle des autres ?",
    "Ta lumière a besoin de contours": "Quelle limite douce rendrait ton prochain oui plus sincère ?",
    "Ce poids n’a plus besoin de voyager avec toi": "Qu’es-tu prête à honorer sans continuer à le porter ?",
    "La porte peut se fermer avec douceur": "Quel cycle semble terminé, même si une partie de toi hésite encore à le reconnaître ?",
    "Ton corps demande moins de lutte": "Que tente peut-être de te dire la partie de ton corps qui reste en tension ?",
    "Ce que tu nommes commence à prendre forme": "Quelle intention souhaites-tu formuler clairement, sans encore chercher comment elle se réalisera ?",
    "Ton intention a besoin d’une place": "Quel geste concret pourrait donner une place réelle à ton désir cette semaine ?",
    "Ce désir mérite d’être nommé": "Quel souhait as-tu rendu plus petit pour qu’il paraisse raisonnable ?",
    "Tu ne te perds pas, tu changes de rive": "Quelle ancienne manière d’être ne peut plus t’accompagner sur la rive suivante ?",
    "L’entre-deux est un passage sacré": "Que se passerait-il si tu cessais de remplir le vide et laissais la nouvelle forme apparaître ?",
    "Ta nouvelle forme n’a pas à ressembler à l’ancienne": "Quelle permission t’aiderait à devenir autrement ?",
    "Pour aujourd’hui, tu n’as rien à accomplir": "De quoi aurais-tu besoin si tu n’avais rien à réussir aujourd’hui ?",
    "Reviens à ce qui est simple": "Quel geste simple pourrait te ramener à toi dans les prochaines minutes ?",
    "Ton corps est ta première maison": "Quelle sensation présente dans ton corps mérite simplement d’être écoutée ?",
    "Toutes tes pensées ne demandent pas une réponse": "Quelle pensée pourrais-tu laisser sans réponse jusqu’à demain ?",
    "Ce qui semble urgent n’est pas toujours essentiel": "Qu’est-ce qui restera important lorsque l’urgence émotionnelle sera retombée ?",
    "La bonne décision n’a pas besoin d’être parfaite": "Quel choix serait suffisamment juste, même s’il n’était pas parfait ?",
    "Ton oui mérite de passer par toi": "Quel oui as-tu donné récemment avant de prendre le temps de t’écouter ?",
    "Ta colère protège peut-être une frontière": "Quelle limite ta colère essaie-t-elle de protéger ?",
    "Tu peux aimer sans être disponible à tout": "À quel endroit ta disponibilité devient-elle un oubli de toi ?",
    "Tu peux déposer le rôle de celle qui tient tout": "Quelle responsabilité pourrais-tu rendre sans abandonner ce qui compte vraiment ?",
    "Ce qui n’a pas été pleuré cherche parfois une rivière": "Quelle tristesse aurait surtout besoin d’être accueillie sans être expliquée ?",
    "Comprendre encore ne changera peut-être plus l’histoire": "Quelle compréhension cherches-tu encore alors que ton cœur demande surtout de la paix ?",
    "Ton désir n’est pas éteint, il manque peut-être d’espace": "Qu’est-ce qui pourrait rallumer doucement ton envie cette semaine ?",
    "Recevoir ne te rend pas passive": "Qu’est-ce que tu pourrais accepter de recevoir sans chercher immédiatement à le rendre ?",
    "La graine demande du temps": "Quelle intention as-tu besoin de nourrir sans vérifier sans cesse si elle a déjà grandi ?",
    "Tu peux faire le deuil de celle que tu pensais devoir devenir": "Quelle ancienne attente envers toi ne correspond plus à la femme que tu deviens ?",
    "Ta puissance revient lorsque tu cesses de te diminuer": "Dans quelle situation réduis-tu encore ta présence pour rester acceptable ?",
    "Tu n’as pas à te reconstruire d’un seul bloc": "Quelle petite partie de ta vie peux-tu reconstruire avec douceur aujourd’hui ?",
    "Ton esprit court peut-être parce qu’il cherche un lieu sûr": "Que remarque ton corps lorsque tu cesses un instant de suivre chaque pensée ?",
    "Le repos n’est pas une récompense": "Que t’autoriserais-tu si ton repos n’avait pas besoin d’être mérité ?",
    "Tu as le droit d’être soutenue": "Où pourrais-tu demander ou accepter un peu de soutien sans renoncer à ton autonomie ?"
  };

  const offerUrls = {
    "Facette de clarté": "https://lylybulle.com/products/%E2%9C%A8-guidance-en-direct-seance-vibratoire-personnalisee",
    "Facette de protection": "https://lylybulle.com/products/%F0%9F%8C%9F-le-bouclier-de-michael-soin-energetique-de-protection-sacree",
    "Facette de libération": "https://lylybulle.com/products/soin-energetique-a-distance-alignement-sacre-de-l-ame",
    "Facette de l’intention": "https://lylybulle.com/products/%F0%9F%8C%9F-guidance-a-3-questions-format-audio-canalisation",
    "Facette de transformation": "https://lylybulle.com/products/accompagnement-signature-la-grande-traversee",
    "Facette de l’ancrage": "https://www.skool.com/le-sancturaire-5932/about"
  };

  const DAILY_KEY = "lyly-cristal-daily-v1";
  const JOURNAL_KEY = "lyly-cristal-journal-v1";
  const HISTORY_KEY = "lyly-cristal-history-v1";
  const today = (() => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    return year + "-" + month + "-" + day;
  })();
  const todayLabel = new Intl.DateTimeFormat("fr-FR", {
    day: "numeric",
    month: "long",
    year: "numeric"
  }).format(new Date());

  const readStorage = (key, fallback) => {
    try {
      const value = window.localStorage.getItem(key);
      return value ? JSON.parse(value) : fallback;
    } catch (error) {
      return fallback;
    }
  };

  const writeStorage = (key, value) => {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
      return true;
    } catch (error) {
      return false;
    }
  };

  const button = root.querySelector(".crystal-touch");
  const status = root.querySelector(".reading-status");
  const result = root.querySelector(".revelation");
  const door = root.querySelector(".door-button");
  const doorNote = root.querySelector(".door-note");
  const reflectionQuestion = root.querySelector(".reflection-question");
  const journalNote = root.querySelector("#crystal-journal-note");
  const saveButton = root.querySelector(".save-message");
  const saveStatus = root.querySelector(".save-status");
  const journalToggle = root.querySelector(".journal-toggle");
  const journalSection = root.querySelector(".crystal-journal");
  const journalList = root.querySelector(".journal-list");
  const exportButton = root.querySelector(".export-journal");
  const clearButton = root.querySelector(".clear-journal");
  const journalActionStatus = root.querySelector(".journal-action-status");
  let chosen = null;
  let chosenIndex = null;
  let clearConfirmationPending = false;
  let clearConfirmationTimer = null;
  const savedDaily = readStorage(DAILY_KEY, null);
  const savedIndex = savedDaily && savedDaily.date === today && Number.isInteger(savedDaily.index)
    ? savedDaily.index
    : null;

  const getJournal = () => {
    const entries = readStorage(JOURNAL_KEY, []);
    return Array.isArray(entries) ? entries : [];
  };

  const renderJournal = () => {
    journalList.replaceChildren();
    const entries = getJournal().slice(0, 7);
    exportButton.disabled = entries.length === 0;
    clearButton.disabled = entries.length === 0;
    if (!entries.length) {
      const empty = document.createElement("p");
      empty.className = "journal-empty";
      empty.textContent = "Ton carnet accueillera ici les messages que tu choisiras de garder.";
      journalList.appendChild(empty);
      return;
    }

    entries.forEach((entry) => {
      const container = document.createElement("article");
      container.className = "journal-entry";
      const date = document.createElement("p");
      date.className = "journal-date";
      date.textContent = entry.dateLabel;
      const title = document.createElement("h4");
      title.textContent = entry.title;
      const note = document.createElement("p");
      note.textContent = entry.note || "Message gardé sans note personnelle.";
      container.append(date, title, note);
      journalList.appendChild(container);
    });
  };

  const revealMessage = () => {
    chosen = messages[chosenIndex];
    result.querySelector(".facet").textContent = chosen.facet;
    result.querySelector(".message-title").textContent = chosen.title;
    result.querySelector(".message-copy").textContent = chosen.copy;
    result.querySelector("blockquote").textContent = "« " + chosen.key + " »";
    result.querySelector(".ritual p").textContent = chosen.ritual;
    reflectionQuestion.textContent = reflectionQuestions[chosen.title];
    door.textContent = chosen.door;
    door.href = offerUrls[chosen.facet];
    door.setAttribute("aria-label", chosen.door + " — ouvre la page dans un nouvel onglet");
    doorNote.hidden = true;
    saveStatus.textContent = "";

    const existingEntry = getJournal().find((entry) => entry.date === today);
    journalNote.value = existingEntry ? existingEntry.note : "";
    status.textContent = savedIndex === null
      ? "Ta facette s’est révélée."
      : "Ton message du jour t’attendait.";
    result.hidden = false;
    result.scrollIntoView({ behavior: "smooth", block: "nearest" });
  };

  if (savedIndex !== null && savedIndex >= 0 && savedIndex < messages.length) {
    status.textContent = "Ton message du jour t’attend dans le cristal.";
  }

  renderJournal();

  button.addEventListener("click", () => {
    if (button.disabled) return;
    button.disabled = true;
    button.classList.add("is-reading");
    status.textContent = "Le cristal écoute ton intention…";

    window.setTimeout(() => {
      if (savedIndex !== null) {
        chosenIndex = savedIndex;
      } else {
        const storedHistory = readStorage(HISTORY_KEY, []);
        const recentHistory = Array.isArray(storedHistory)
          ? storedHistory.filter((index) => Number.isInteger(index)).slice(0, 7)
          : [];
        const availableIndexes = messages
          .map((message, index) => index)
          .filter((index) => !recentHistory.includes(index));
        const selectionPool = availableIndexes.length ? availableIndexes : messages.map((message, index) => index);
        chosenIndex = selectionPool[Math.floor(Math.random() * selectionPool.length)];
        writeStorage(HISTORY_KEY, [chosenIndex, ...recentHistory.filter((index) => index !== chosenIndex)].slice(0, 7));
      }
      if (savedIndex === null) {
        writeStorage(DAILY_KEY, { date: today, index: chosenIndex });
      }
      revealMessage();
    }, 2200);
  });

  saveButton.addEventListener("click", () => {
    if (!chosen || chosenIndex === null) return;
    const entries = getJournal().filter((entry) => entry.date !== today);
    entries.unshift({
      date: today,
      dateLabel: todayLabel,
      index: chosenIndex,
      facet: chosen.facet,
      title: chosen.title,
      key: chosen.key,
      note: journalNote.value.trim()
    });
    const saved = writeStorage(JOURNAL_KEY, entries.slice(0, 30));
    saveStatus.textContent = saved
      ? "Ton message a rejoint le Carnet cristallin."
      : "La mémoire privée n’est pas disponible dans cet aperçu.";
    renderJournal();
  });

  journalToggle.addEventListener("click", () => {
    const willOpen = journalSection.hidden;
    journalSection.hidden = !willOpen;
    journalToggle.setAttribute("aria-expanded", String(willOpen));
    journalToggle.textContent = willOpen
      ? "Refermer mon Carnet cristallin"
      : "Ouvrir mon Carnet cristallin";
    if (willOpen) renderJournal();
  });

  exportButton.addEventListener("click", () => {
    const entries = getJournal();
    if (!entries.length) return;
    const content = [
      "MON CARNET CRISTALLIN",
      "Le Cristal du Sanctuaire — LyLy Bulle",
      "",
      ...entries.flatMap((entry) => [
        entry.dateLabel,
        entry.facet,
        entry.title,
        "Clé : « " + entry.key + " »",
        "Mes mots : " + (entry.note || "Message gardé sans note personnelle."),
        "",
        "— · —",
        ""
      ])
    ].join("\n");
    const blob = new Blob([content], { type: "text/plain;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "mon-carnet-cristallin.txt";
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
    journalActionStatus.textContent = "Ton carnet a été préparé pour être emporté.";
  });

  clearButton.addEventListener("click", () => {
    if (!clearConfirmationPending) {
      clearConfirmationPending = true;
      clearButton.textContent = "Confirmer l’effacement";
      journalActionStatus.textContent = "Cette action effacera définitivement les notes conservées sur cet appareil.";
      clearConfirmationTimer = window.setTimeout(() => {
        clearConfirmationPending = false;
        clearButton.textContent = "Effacer mon carnet";
        journalActionStatus.textContent = "L’effacement a été annulé.";
      }, 8000);
      return;
    }

    window.clearTimeout(clearConfirmationTimer);
    try {
      window.localStorage.removeItem(JOURNAL_KEY);
      journalNote.value = "";
      journalActionStatus.textContent = "Ton Carnet cristallin a été effacé de cet appareil.";
    } catch (error) {
      journalActionStatus.textContent = "L’effacement n’a pas pu être effectué dans cet aperçu.";
    }
    clearConfirmationPending = false;
    clearButton.textContent = "Effacer mon carnet";
    renderJournal();
  });

  door.addEventListener("click", () => {
    if (!chosen) return;
    doorNote.textContent = chosen.destination;
    doorNote.hidden = false;
  });
})();

  } catch(e) { console.error(e); }
})();
})();
